
                <div class="body main-container">
                    <div class="form-group genaration-dropdown">
                        
    
                        <!-- <div *ngIf="!Demo"> -->
                            <div class="card">
                                <h2>Premium Membership</h2>
                                <p class="price">$890</p>
                                <p>Please Upgrade 1 year premium membership to access premium reports</p>
                                <p><button>
                                        <a target="_blank" href="https://shop.embla.no/home">Upgrade Now</a>
                                    </button></p>
                            </div>
                        <!-- </div> -->
                    </div>
    
    
    
                    <!-- <div class="form-group genaration-dropdown">
                            <label *ngIf="reportTitle">{{"title" | translate}}</label>
                            <input *ngIf="reportTitle" type="text" class="form-control reportTitle-text" [(ngModel)]="reportTitle">
                            <label>{{"lbl_number_of_genarations" | translate}}</label>
                            <select class="form-control dropdown-list" [(ngModel)]="selectedGenaration"
                                (change)='onChange($event)'>
                                <option *ngFor='let option of dropDownData' [value]="option">{{option}}</option>
                            </select>
                        </div> -->
                </div>
    
    
    
                